import AsyncStorage from '@react-native-async-storage/async-storage';

/** 첫 실행 화면을 봤는지. 기기에만 남기고 계정과 묶지 않는다 (로그인 전에 보는 화면이라서). */
const KEY = 'welcome_seen_v1';

export async function hasSeenWelcome(): Promise<boolean> {
  try {
    return (await AsyncStorage.getItem(KEY)) === '1';
  } catch {
    return true; // 저장소를 못 읽으면 첫 화면으로 가두지 않는다
  }
}

export async function markWelcomeSeen(): Promise<void> {
  await AsyncStorage.setItem(KEY, '1').catch(() => {});
}

/** 첫 화면을 다시 보려고 표시를 지운다. 앱 데이터를 지우면 로그인까지 풀려서 그 대신 쓴다. */
export async function resetWelcome(): Promise<void> {
  await AsyncStorage.removeItem(KEY).catch(() => {});
}
